(() => {
  if (window.bmsLeadAttribution) return;
  const key = 'bms_google_lead_attribution_v1';
  const ttl = 90 * 24 * 60 * 60 * 1000;
  const clickFields = ['gclid', 'gbraid', 'wbraid'];
  const query = new URLSearchParams(window.location.search);
  const incoming = Object.fromEntries(clickFields.flatMap(name => {
    const value = query.get(name);
    return value && /^[A-Za-z0-9_-]{1,512}$/.test(value) ? [[name, value]] : [];
  }));
  const landedAt = new Date().toISOString();
  let loaded = false;
  const allowed = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.marketingAllowed() === true && privacy?.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  };
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || 'null');
      const age = Date.now() - Date.parse(value?.captured_at);
      if (!value || !Number.isFinite(age) || age < 0 || age > ttl) {
        localStorage.removeItem(key);
        return {};
      }
      return Object.fromEntries(clickFields.filter(name => /^[A-Za-z0-9_-]{1,512}$/.test(value[name] || '')).map(name => [name, value[name]]).concat([['captured_at', value.captured_at]]));
    } catch (_) { return {}; }
  };
  const refresh = () => {
    if (!allowed()) {
      try { localStorage.removeItem(key); } catch (_) {}
      return;
    }
    if (Object.keys(incoming).length) {
      const existing = read();
      const sameClick = clickFields.every(name => incoming[name] === existing[name]);
      if (!sameClick) {
        try { localStorage.setItem(key, JSON.stringify({ ...incoming, captured_at: landedAt })); } catch (_) {}
      }
    }
  };
  window.bmsLeadAttribution = () => {
    refresh();
    if (!allowed()) return null;
    return { version: 1, ...read(), ad_user_data: 'GRANTED', consent_checked_at: new Date().toISOString() };
  };
  document.addEventListener('visitorConsentCollected', refresh);
  const initialize = () => {
    if (window.Shopify?.customerPrivacy) { refresh(); return; }
    if (!loaded && typeof window.Shopify?.loadFeatures === 'function') {
      loaded = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => { if (!error) refresh(); });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
